import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/common/ProtectedRoute';
import Layout from './components/Layout.jsx';
import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import OnboardClinic from './pages/OnboardClinic';
import OnboardNewClinic from './pages/OnboardNewClinic';
import ManageClinic from './pages/ManageClinic';
import ClinicDetails from './pages/ClinicDetails';
import ComingSoon from './pages/ComingSoon';
import './App.css';

function App() {
    return (
        <AuthProvider>
            <Router>
                <Routes>
                    {/* Public routes */}
                    <Route path="/login" element={<Login />} />
                    <Route path="/signup" element={<Signup />} />
                    
                    {/* Protected routes */}
                    <Route element={
                        <ProtectedRoute>
                            <Layout />
                        </ProtectedRoute>
                    }>
                        <Route index element={<Navigate to="/dashboard" replace />} />
                        <Route path="/dashboard" element={<Dashboard />} />
                        <Route path="/clinics">
                            <Route path="onboard" element={<OnboardClinic />} />
                            <Route path="onboard/new" element={<OnboardNewClinic />} />
                            <Route path="manage" element={<ManageClinic />} />
                            <Route path=":id" element={<ClinicDetails />} />
                        </Route>
                        {/* New routes for better URL structure */}
                        <Route path="/onboard/clinics/clinic-details/:slug" element={<ClinicDetails />} />
                        <Route path="/manage/clinic/clinic-details/:slug" element={<ClinicDetails />} />
                        <Route path="/user-management" element={<ComingSoon />} />
                    </Route>
                </Routes>
            </Router>
        </AuthProvider>
    );
}

export default App;
